module.exports = "/images/bold-icon.svg?501d67e400a81551bbc99fdd1269ed63";